import React, { useState } from "react";
import { shallow } from "zustand/shallow";
import { useNavigate } from "react-router-dom";
import { Button, TextInput, Space } from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";

import { CustomTooltip } from "@components/shared";
import { SectionTitle } from "./WizardComponents";
import { initialState as auctionInitialSettings } from "@components/Auction/AuctionSettings/helpers";
import { initialAuctionItemSettings } from "@components/Prize/helpers";
import {
  initialState as effortInitialSettings,
  generateEffortRebounds,
} from "@components/Effort/EffortSettings/helpers";
import { effortWizardSettings } from "@components/Effort/helpers";
import { initialConfig as initialMicrositeConfig } from "@components/shared/MicrositeSettings/helpers";
import { contestWizardSettings } from "@components/Contest/helpers";
import { defaultEffortConfig } from "@components/Effort/helpers";

import useAppStore from "./wizard-store";

export default function WizardAuction() {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { contestSettings, location, organization, setContestSettings } =
    useAppStore(
      (state) => ({
        contestSettings: state.contestSettings,
        location: state.location,
        organization: state.organization,
        setContestSettings: state.setContestSettings,
      }),
      shallow
    );

  function onSubmit() {
    const req = {
      create_auction: {
        ...contestSettings,
        location_id: location ? location.id : null,
        organization_id: organization ? organization.id : null,
        variety: 3,
        settings: {
          ...auctionInitialSettings,
        },
        wizard_settings: {
          ...contestWizardSettings,
          dates_required: true,
          featured_image_required: true,
          min_starting_bid_required: true,
          max_bid_increment_required: true,
        },
        prize: {
          // settings: initialPrizeSettings,
          settings: initialAuctionItemSettings,
          name: `${contestSettings.name} Prize`,
          // description: "A description of this prize",
          description: "",
        },
        create_effort: {
          title: `${contestSettings.name} Auction Effort`,
          recurring_engagement: 2,
          award_type: 1,
          location_id: location ? location.id : null,
          organization_id: organization ? organization.id : null,
          draft_app_configuration: initialMicrositeConfig,
          draft_configuration: defaultEffortConfig,
          variety: 3,
          settings: {
            ...effortInitialSettings,
            ...generateEffortRebounds(contestSettings.name),
          },
          wizard_settings: {
            ...effortWizardSettings,
            recurring: false,
            show_assets: false,
            show_award_type: false,
            show_awards: true,
            show_builder: false,
            show_csv: false,
            show_geospots: false,
            show_interaction_type: false,
            show_keywords: false,
            show_look_feel: false,
            show_quick_settings: false,
          },
        },
      },
    };

    axios
      .post(`/wizard/`, req)
      .then(({ data }) => {
        setLoading(false);
        navigate(`/auctions/${data.response[0].contest_id}`);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const submitDisabled = !contestSettings.name || (!location && !organization);

  return (
    <div>
      <React.Fragment>
        <Space mt="lg" />
        <CustomTooltip label="Auction names will be visible to the users.">
          <SectionTitle text="Tell us a little more" />
        </CustomTooltip>
        <TextInput
          label="Auction Name"
          maxLength={100}
          value={contestSettings.name}
          onChange={(e) =>
            setContestSettings({
              ...contestSettings,
              name: e.target.value,
            })
          }
        />
        <Button
          mt="sm"
          fullWidth
          onClick={onSubmit}
          loading={loading}
          disabled={submitDisabled}
        >
          Create
        </Button>
      </React.Fragment>
    </div>
  );
}
